import MeddiGridItem from './MeddiGridItem';

interface MeddiGridProps {
	items: any[];
	template: any;
}

export default function MeddiGrid(props: MeddiGridProps) {
	const { items, template } = props;

	if (!items) {
		return <p>no results</p>;
	}

	return items.map((item, index) => (
		<div key={index}>
			<MeddiGridItem item={item} template={template} />
		</div>
	));
}
